import serializeObject from '@arsenal/arsenal/modules/serializeObject'
import getUrl from './url'
import fetch from 'lib/decorated-fetch'
interface DiggParams {
  user_id: number
  group_id: string
  action: 'digg' | 'cancel_digg'
  like_type?: 'digg_pgc_article' | 'digg_pgc_video'
}
export const digg = ({
  user_id,
  group_id,
  action,
  like_type = 'digg_pgc_article',
}: DiggParams) => {
  const params = {
    user_id,
    thread_id: group_id,
    digg_action: action,
    like_type,
    group_id,
  }
  let request = null
  request = fetch(getUrl(`/motor/community/digg_like`), {
    method: 'POST',
    headers: {
      'tt-anti-token': window.localStorage.getItem('tt-anti-token') || '',
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: serializeObject(params),
  })
  return request
    .then(res => {
      const { err_no, err_tips } = res
      if (err_no) {
        return Promise.reject(err_tips)
      } else {
        return Promise.resolve()
      }
    })
    .catch(err => {
      console.log(err)
      return Promise.reject('点赞失败')
    })
}
